import helmetSpartanAsset from "@assets/helmet/helmet_spartan/helmet_spartan.fbx";
import helmetSpartanMetalKnightTextureAsset from "@assets/helmet/helmet_spartan/metalKnight.png";
import helmetSpartanShogunTextureAsset from "@assets/helmet/helmet_spartan/shogun.png";
import helmetHoodAsset from "@assets/helmet/helmet_hood/helmet_hood.fbx";
import helmetHoodAssassinTextureAsset from "@assets/helmet/helmet_hood/helmet_hood_assassin.png";

export const HelmetAssetMap = {
  helmetSpartan: {
    fileName: helmetSpartanAsset,
    unwrap: true,
  },
  helmetSpartanMetalKnightTexture: {
    fileName: helmetSpartanMetalKnightTextureAsset,
  },
  helmetSpartanShogunTexture: {
    fileName: helmetSpartanShogunTextureAsset,
  },
  helmetHood: {
    fileName: helmetHoodAsset,
    unwrap: true,
  },
  helmetHoodAssassinTexture: {
    fileName: helmetHoodAssassinTextureAsset,
  },
} as const;
